import _classCallCheck from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js";
import _inherits from "/Users/markovrbancic/Work/valentino_workspace/foursight/admin/node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module indent/indent
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import IndentEditing from "./indentediting";
import IndentUI from "./indentui";
/**
 * The indent feature.
 *
 * This plugin acts as a single entry point plugin for other features that implement indentation of elements like lists or paragraphs.
 *
 * The compatible features are:
 *
 * * The {@link module:list/list~List} or {@link module:list/listediting~ListEditing} feature for list indentation.
 * * The {@link module:indent/indentblock~IndentBlock} feature for block indentation.
 *
 * This is a "glue" plugin that loads the following plugins:
 *
 * * The {@link module:indent/indentediting~IndentEditing indent editing feature}.
 * * The {@link module:indent/indentui~IndentUI indent UI feature}.
 *
 * The dependent plugins register the `'indent'` and `'outdent'` commands and introduce the `'indent'` and `'outdent'` buttons
 * that allow to increase or decrease text indentation of supported elements.
 *
 * **Note**: In order for the commands and buttons to work, at least one of compatible features is required.
 *
 * @extends module:core/plugin~Plugin
 */

var Indent =
/*#__PURE__*/
function (_Plugin) {
  _inherits(Indent, _Plugin);

  function Indent() {
    _classCallCheck(this, Indent);

    return _possibleConstructorReturn(this, _getPrototypeOf(Indent).apply(this, arguments));
  }

  _createClass(Indent, null, [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'Indent';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [IndentEditing, IndentUI];
    }
  }]);

  return Indent;
}(Plugin);

export { Indent as default };